import React from "react"

export default function Clients() {
    return (
        <div className="mx-auto text-center space-y-10 pt-16 mb-24">
            <h1 className="mx-auto text-sm font-bold tracking-widest uppercase border-b pb-4 border-gray-900 max-w-xs lg:max-w-lg">Selected Clients</h1>
            <div className="clients flex flex-col items-center justify-between max-w-4xl mx-auto space-y-16 lg:flex-row lg:space-y-0 lg:mb-16">
                <img className="max-w-[160px]" src="/img/clients_logos/jackrabbit.png"></img>
                <img className="max-w-xs" src="/img/clients_logos/lionsgate.png"></img>
                <img className="max-w-[160px]" src="/img/clients_logos/dnd.png"></img>
            </div>
        </div>
    )
}